// Headway is the third-party service that powers the "What's New" popup
// triggered by .navbar-whats-new buttons in the nav bar (see templates/base/head_navbar.tmpl).
import {event} from '../analytics.ts';

export function initHeadwayTracking() {
  for (const btn of document.querySelectorAll('.navbar-whats-new')) {
    btn.addEventListener('click', () => {
      event('latest_updates_clicked');
    });
  }
  mirrorHeadwayBadgeToMobile();
}

// Headway injects its badge into .navbar-whats-new.not-mobile (the desktop button) only.
// Mirror it to the mobile button so the unread count is visible on small screens too.
function mirrorHeadwayBadgeToMobile() {
  const desktopBtn = document.querySelector<HTMLElement>('.navbar-whats-new.not-mobile');
  const mobileBtn = document.querySelector<HTMLElement>('.navbar-whats-new:not(.not-mobile)');
  if (!desktopBtn || !mobileBtn) return;

  const observer = new MutationObserver(() => {
    const desktopBadge = desktopBtn.querySelector('.HW_badge_cont');
    const mobileBadge = mobileBtn.querySelector('.HW_badge_cont');
    if (desktopBadge) {
      const clone = desktopBadge.cloneNode(true) as Element;
      if (mobileBadge) {
        mobileBadge.replaceWith(clone);
      } else {
        mobileBtn.append(clone);
      }
      // Disconnect once the badge has settled into its final state — either showing a count
      // or marked HW_softHidden by Headway. Further updates require a page reload.
      const innerBadge = desktopBadge.querySelector('.HW_badge');
      if (innerBadge?.classList.contains('HW_softHidden') || innerBadge?.textContent?.trim()) {
        observer.disconnect();
      }
    } else if (mobileBadge) {
      mobileBadge.remove();
    }
  });
  observer.observe(desktopBtn, {childList: true, subtree: true, characterData: true, attributes: true});
}
